import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-conception',
  templateUrl: './conception.component.html',
  styleUrls: ['./conception.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ConceptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
